import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=0d1f1e6c&scoped=true"
import script from "./infoPage.vue?vue&type=script&lang=js"
export * from "./infoPage.vue?vue&type=script&lang=js"
import style0 from "./infoPage.vue?vue&type=style&index=0&id=0d1f1e6c&prod&lang=css"
import style1 from "./infoPage.vue?vue&type=style&index=1&id=0d1f1e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f1e6c",
  null
  
)

export default component.exports